import React from 'react'

const Immigrationandidentity = () => {
  return (
    <div>
      <div>
        <h3>Ways with words</h3>
        <p className='question'>A. Words from the text to solve the crossword puzzle:</p>
        <strong>Across</strong>
        <p>2. as is certain to happen <strong>inevitably</strong></p>
        <p>4. famous and respected <strong>eminent</strong></p>
        <p>6. a temporary stay <strong>sojourn</strong></p>
        <p>7. knowing everything <strong>omniscient</strong></p>
        <strong>Down</strong>
        <p>1. the state of being preoccupied <strong>preoccupation</strong></p>
        <p>3. anxious or fearful that something bad will happen <strong>apprehensive</strong></p>
        <p>5. a person of mixed white and black ancestry <strong>mulatto</strong></p>
      </div>
      <hr/>
      <div>
        <p className='question'>B. Find the meanings of the following words in a dictionary as they are used in the text.</p>
        <strong>a. melancholy</strong>
        <p>Melancholy means a deep, long-lasting feeling of sadness or gloom. </p>
        <strong>b. elusive</strong>
        <p>Elusive means something that is difficult to find, catch, or understand.</p>
        <strong>c. motif</strong>
        <p>Motif means a recurring theme, idea, or pattern in a work of art, literature, or music that helps convey a particular message or mood.</p>
        <strong>d. disdain</strong>
        <p>Disdain means a feeling of strong dislike or disrespect toward someone</p>
        <strong>e. fabricate</strong>
        <p>Fabricate means to make up or invent something, usually something false or untrue, like a story or an excuse.</p>
        <strong>f. intoxicate</strong>
        <p>Intoxicate means to make someone feel drunk or under the influence of alcohol or drugs.</p>
        <strong>g. resentment</strong>
        <p>Resentment means a feeling of anger or bitterness</p>
      </div>
      <hr/>
      <div>
        <p className='question'>D. Choose the right word to fill in the blanks.</p>
        <p >a. Can you <strong>bury</strong> the box in the back garden? (bury/berry)</p>
        <p>b. Alex could not <strong>break</strong> the branch off the tree. (break/brake)</p>
        <p>c. <strong>Whose</strong> pencil is on the floor? (Who's/Whose)</p>
        <p>d. We have got very <strong>few</strong> (phew/few) tasks left.</p>
        <p>e. Some tribes worship their gods before they <strong>prey</strong>. (prey/pray)</p>
        <p>f. <strong>Damn</strong> it. Everything is messed up. (Dam /Damn)</p>
        <p>g. What a wonderful <strong>lesson</strong> the professor presented. (lesson/lessen)</p>
      </div>
      <hr/>
      <div>
        <h3>Comprehension</h3>
        <p className='question'>Answer these questions.</p>
        <p className='question'>a. How is Willie Chandran different from the rest of his family?</p>
        <p>= Willie Chandran is different from his family because he feels unsure about himself and his identity. He doesn't feel confident like others around him.</p>
        <p className='question'>b. Who is the main character of Half A Life? How is he described?</p>
        <p>= Willie Chandran is the main character. He was born in India about 40 years ago. His father is a Brahmin and his mother is poor. His middle name comes from the English writer Somerset Maugham.</p>
        <p className='question'>c. Why does Willie leave India?</p>
        <p>= Willie leaves India because he doesn't have a clear identity there. Being the son of a high caste father and a low caste mother makes his life difficult. He feels hatred for his father and wins a scholarship to study in London.</p>
        <p className='question'>d. What is the revelation that Willie begin to feel in college and in London?</p>
        <p>= In London, Willie feels more free and safe. He realizes he can create a new identity for himself, unlike in India where caste and race limit him.</p>
        <p className='question'>e. Why does Willie accompany Ana?</p>
        <p>= Willie stays with Ana because she belongs to a higher social status in her colonial world. Being with her helps him feel accepted.</p>
        <p className='question'>f. What is the central issue Naipal has raised in the novel?</p>
        <p>= Naipal raises the problem of identity crisis in the novel, especially about ethnicity and culture.</p>
      </div>
      <hr/> 
      <div>
        <h3>Critical Thinking</h3>
        <p className='question'>a. What kind of divided identity is depicted in the novel 'Half a Life'? How do characters in the novel try to create new identities for themselves? Explain.</p>
        <p>= The novel Half a Life shows how some people struggle with having a divided or mixed identity. The story mainly focuses on three characters: Willie, Ana, and a man with big light eyes. Willie, who is the main character, has a divided identity because his father is a high-caste Brahmin and his mother is from a lower caste. In India, this causes him to feel insecure and confused about who he really is. He doesn't feel comfortable in India because of discrimination based on caste. So, he decides to move to London to find freedom and create a new identity for himself.
</p><p>
Ana is another character with a mixed identity. She is part Portuguese and part African. Like Willie, she also struggles to find where she belongs. When Ana comes to London, she tries to figure out her own identity. Later, she goes back to her country, which is a Portuguese-African colony, hoping to have a higher status there—even if it means pretending to be someone else to hide her true past.
</p><p>
Willie follows Ana to her country hoping he will be accepted there, but he also feels lost. He sees how some people, like an illegitimate man born to an African mother and Portuguese father, suffer because of their background. These people are treated badly by others just because of their birth. This shows how hard it is for people with mixed or divided identities to find their place in the world.
</p><p>
In short, the novel Half a Life shows the struggles of people trying to find themselves when their identity is divided by race, culture, or history. They try to make new identities by moving to new places or acting differently, but it's not always easy to feel fully accepted.</p>
      </div>
      <hr/>
      <div>
        <p className='question'>b. Discuss the similaries between the author and the protagonist in the noivel?</p>
        <p>= There are many things in common between the writer V.S. Naipaul and the main character Willie Chandran from the novel Half a Life. Both of them were born in countries where they felt like they didn't fully belong. Naipaul was born in Trinidad, but his family came from India. Willie was born in India, but he always felt uncomfortable because his parents were from different castes. This made him feel like he didn't have a clear identity.
</p><p>
Like Willie, Naipaul also left his home at a young age to study in England. They both got scholarships and spent several years there. During their time in England, they both became interested in writing. Willie wrote a book while studying in London, and Naipaul also became a writer and wrote many books throughout his life.
</p><p>
Another similarity is that both Naipaul and Willie lived far from their home countries. They experienced life in new places and had to deal with feelings of confusion and not fully fitting in. It seems like the author used his own experiences to create the character of Willie. Because of that, the story feels more real and relatable. Naipaul probably understood how Willie felt because he had gone through similar things himself.</p>
      </div>
      <hr/>
      <div>
        <h3>Writing</h3>
        <p className='question'>B. Write a review of a book/film you have recently read or watched.</p>
        <p>Book Review: Seto Dharti</p><p>
Author: Amar Neupane</p><p>
Published Date: 2012</p><p>
Genre: Historical Fiction / Social Realism</p><p>
Number of Pages: Around 356 pages</p><p>
Language: Nepali</p><p>

Seto Dharti is a powerful and emotional Nepali novel written by Amar Neupane. It tells the heartbreaking story of a girl named Tara, who becomes a widow at a very young age and has to live her entire life under the strict rules of society. The book is set in old Nepalese society, where child marriage and widowhood were very common and painful for girls.
</p><p>
Tara's journey starts with innocence and ends in silence and loneliness. Even though she loses her childhood, her husband, and freedom, she never complains or becomes bitter. This makes her a very strong and inspiring character.
</p><p>
The novel uses simple and beautiful language, which makes it easy to understand and emotional to read. The descriptions are so good that you can imagine the village life, customs, and struggles clearly in your mind.
</p><p>
Seto Dharti teaches us about the unfair traditions that existed in our society, especially for women. It encourages us to think about change and treat everyone with respect and love.
</p><p>
I recommend this book to anyone who enjoys meaningful and touching stories. It's not just a story about one girl, it's a story of many girls who suffered silently.</p>
      </div>
      <hr/>
      <div>
        <h3>Grammar</h3>
        <p className='question'>Change the following into indirect speech.</p>
        <p>a. She said, "While I was having dinner, the phone rang."</p>
        <p>= She said that while she was having dinner, the phone had rung.</p>
        <br/>
        <p>b. My friend said, "Where are they staying?"</p>
        <p>= My friend asked where they were staying.</p>
        <br/>
        <p>c. Jamila said, "I travel a lot in my job."</p>
        <p>= Jamila said that she travelled a lot in her job.</p>
        <br/>
        <p>d. She said to me, "We lived in China for five years."</p>
        <p>= She told me that they had lived in China for five years.</p>
        <br/>
        <p>e. He said to me, "Do you like ice-cream?"</p>
        <p>= He asked me if I liked ice-cream.</p>
        <br/>
        <p>f. They said, "Hurray! We've won the match."</p>
        <p>= They exclaimed with joy that they had won the match.</p>
        <br/>
        <p>g. He said, "I'd tried everything without success, but this new medicine is great."</p>
        <p>= He said that he had tried everything without success, but that the new medicine was great.</p>
        <br/>
        <p>h. Sony said, "I go to the gym next to your house."</p>
        <p>= Sony said that she went to the gym next to my house.</p>
        <br/>
        <p>i. He said, "Be quiet after 10 o'clock."</p>
        <p>= He told me to be quiet after 10 o'clock.</p>
        <br/>
        <p>j. He said, "I don't want to go to the party unless he invites me."</p>
        <p>= He said that he didn't want to go to the party unless he invited him.</p>
        <br/>
        <p>k. He said to me, "I will see you tomorrow if you meet me."</p>
        <p>= He told me that he would see me the next day if I met him.</p>
        <br/>
        <p>l. She said, "If I were you, I would give up the work."</p>
        <p>= She said that if she were me, she would give up the work.</p>
      </div>
    </div>
  )
}

export default Immigrationandidentity
